/* Top Racing Point - Ricerca distanziali (22/10/2026)
   Due schede: "Per la tua auto" (Marca > Modello > foratura/foro centrale dal file trp-dist-auto.js)
   e "Per misure" (Tipo > Foratura > Foro centrale > Spessore).
   Legge i tag dei prodotti della collezione Distanziali (template collection.trpauto):
   "distanziali semplici", "distanziali doppia bulloneria", "adattatori cambio foratura",
   "pcd 4x108", "foratura cerchio 5x114.3", "foro centrale 65.1", "spessore 20", "filettatura m12x1.25".
   Il pulsante apre la collezione filtrata per tag: /collections/<gruppo>/pcd-4x108+foro-centrale-65-1?auto=... */
(function(){
  var MADRE='distanziali';
  var TIPI={'distanziali semplici':'semplici','distanziali doppia bulloneria':'doppia','adattatori cambio foratura':'adattatori','distanziali universali':'universali','bulloni e dadi ruota':'bulloni','guide ruota':'guide','distanziali su misura':'sumisura'};
  var TAG_TIPO={}; for(var t in TIPI){ TAG_TIPO[TIPI[t]]=t; }
  var GRUPPO={semplici:'distanziali-semplici',doppia:'distanziali-doppia-bulloneria',adattatori:'adattatori-cambio-foratura',universali:'distanziali-universali',bulloni:'bulloni-dadi-ruota',guide:'guide-ruota'};
  var TIPO_DI_GRUPPO={}; for(var g in GRUPPO){ TIPO_DI_GRUPPO[GRUPPO[g]]=g; }
  var NOMI_TIPO={semplici:'Distanziali',doppia:'Distanziali a doppia bulloneria',adattatori:'Adattatori cambio foratura'};
  var TIPI_SCELTA=['semplici','doppia','adattatori'];
  var COLONNETTE={'m12x1.25':1,'m12x1.5':1,'m14x1.5':1,'m14x1.25':1};

  function ready(fn){ if(document.readyState!=='loading'){ fn(); } else { document.addEventListener('DOMContentLoaded', fn); } }
  function handleize(t){ return String(t).toLowerCase().normalize('NFD').split('').filter(function(ch){ var k=ch.charCodeAt(0); return k<768 || k>879; }).join('').replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,''); }
  function esc(t){ return String(t).replace(/[&<>"]/g,function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function tagDi(k,v){
    if(k==='t') return TAG_TIPO[v];
    if(k==='p') return 'pcd '+v;
    if(k==='f') return 'foratura cerchio '+v;
    if(k==='c') return 'foro centrale '+v;
    if(k==='s') return 'spessore '+v;
    if(k==='th') return 'filettatura '+v;
    return v;
  }
  function etichetta(k,v){
    if(k==='t') return NOMI_TIPO[v]||v;
    if(k==='c' || k==='s') return v+' mm';
    if(k==='th') return v.toUpperCase();
    return v;
  }
  function ordina(k){ return function(a,b){
    if(k==='t') return TIPI_SCELTA.indexOf(a)-TIPI_SCELTA.indexOf(b);
    if(k==='p' || k==='f'){ var x=a.split('x'), y=b.split('x'); return (+x[0]-y[0]) || (+x[1]-y[1]); }
    return parseFloat(a)-parseFloat(b);
  }; }

  function leggi(righe){
    return righe.map(function(r){
      var m={t:{},p:{},f:{},c:{},s:{},th:{}};
      (r[1]||[]).forEach(function(tag){
        var l=String(tag).toLowerCase().trim(), x;
        if(TIPI[l]) m.t[TIPI[l]]=1;
        else if((x=l.match(/^pcd (\d+x[\d.]+)$/))) m.p[x[1]]=1;
        else if((x=l.match(/^foratura cerchio (\d+x[\d.]+)$/))) m.f[x[1]]=1;
        else if((x=l.match(/^foro centrale ([\d.]+)$/))) m.c[x[1]]=1;
        else if((x=l.match(/^spessore ([\d.]+)$/))) m.s[x[1]]=1;
        else if((x=l.match(/^filettatura (m[\d.x]+)$/))) m.th[x[1]]=1;
      });
      return m;
    });
  }
  function combacia(m,scelte){ for(var k in scelte){ if(scelte[k] && !m[k][scelte[k]]) return false; } return true; }
  function conta(dati,scelte){ var n=0; dati.forEach(function(m){ if(combacia(m,scelte)) n++; }); return n; }
  function valori(dati,k,altre){
    var c={};
    dati.forEach(function(m){ if(!combacia(m,altre)) return; for(var v in m[k]){ c[v]=(c[v]||0)+1; } });
    return Object.keys(c).sort(ordina(k)).map(function(v){ return [v,c[v]]; });
  }
  function carica(fatto){
    var tutti=[], base='/collections/'+MADRE;
    function pagina(n){ return fetch(base+'?view=trpauto&page='+n,{credentials:'same-origin'}).then(function(r){ return r.text(); }).then(function(t){ return JSON.parse(t); }); }
    pagina(1).then(function(j){
      tutti=tutti.concat(j.p||[]);
      var resto=[]; for(var i=2;i<=(j.pagine||1);i++){ resto.push(pagina(i)); }
      return Promise.all(resto);
    }).then(function(altre){ altre.forEach(function(j){ tutti=tutti.concat(j.p||[]); }); fatto(leggi(tutti)); })
      .catch(function(){ fatto(null); });
  }
  function opzione(v,l){ var o=document.createElement('option'); o.value=v; o.textContent=l; return o; }
  function riempi(sel,lista,vuota,k,tieni){
    var prima=tieni ? sel.value : '';
    sel.innerHTML=''; sel.appendChild(opzione('',vuota));
    lista.forEach(function(x){ sel.appendChild(opzione(x[0], etichetta(k,x[0])+(x[1]!=null?' ('+x[1]+')':''))); });
    if(prima && lista.some(function(x){ return x[0]===prima; })) sel.value=prima;
    sel.disabled=!lista.length;
  }
  function memo(chiave,valore){ try{ if(valore===undefined) return window.localStorage.getItem(chiave); if(valore===null) window.localStorage.removeItem(chiave); else window.localStorage.setItem(chiave,valore); }catch(e){ return null; } return null; }

  ready(function(){
    var root=document.querySelector('[data-trp-dist]');
    if(!root) return;
    var qui=root.getAttribute('data-handle')||MADRE;
    var AUTO=window.TRP_DIST_AUTO||{};
    var pannelli={}, schede=[].slice.call(root.querySelectorAll('[data-trp-tab]'));
    [].slice.call(root.querySelectorAll('[data-trp-panel]')).forEach(function(p){ pannelli[p.getAttribute('data-trp-panel')]=p; });
    function sel(pan,k){ return pannelli[pan].querySelector('[data-trp-sel="'+k+'"]'); }
    function mostraScheda(nome){
      schede.forEach(function(b){ var on=b.getAttribute('data-trp-tab')===nome; b.classList.toggle('is-active',on); b.setAttribute('aria-selected',on?'true':'false'); });
      for(var p in pannelli){ pannelli[p].hidden=(p!==nome); }
    }
    schede.forEach(function(b){ b.addEventListener('click',function(){ mostraScheda(b.getAttribute('data-trp-tab')); }); });
    var riepilogo=root.querySelector('[data-trp-riepilogo]');
    var schedaAuto=root.querySelector('[data-trp-scheda-auto]');

    // Marche e modelli (non servono i prodotti)
    var selMarca=sel('auto','marca'), selMod=sel('auto','modello'), selForo=sel('auto','p');
    selMarca.innerHTML=''; selMarca.appendChild(opzione('','Scegli la marca'));
    Object.keys(AUTO).forEach(function(m){ selMarca.appendChild(opzione(m,m)); });
    selMarca.disabled=false;
    function modelliDi(m){ return AUTO[m]||[]; }
    function autoScelta(){
      var m=selMarca.value, mo=selMod.value; if(!m || !mo) return null;
      var r=null; modelliDi(m).forEach(function(x){ if(x[0]===mo) r=x; });
      return r ? {marca:m, modello:mo, fit:r[1]} : null;
    }
    function riempiModelli(){
      selMod.innerHTML=''; selMod.appendChild(opzione('', selMarca.value ? 'Scegli il modello' : 'Prima la marca'));
      modelliDi(selMarca.value).forEach(function(x){ selMod.appendChild(opzione(x[0],x[0])); });
      selMod.disabled=!selMarca.value;
    }

    carica(function(dati){
      if(!dati){ root.querySelector('[data-trp-errore]').hidden=false; return; }
      var tipoQui=TIPO_DI_GRUPPO[qui]||'';

      // ---------- Scheda "Per misure" ----------
      var ORD_M=['t','p','f','c','s'];
      function scelteMisure(){ var s={}; ORD_M.forEach(function(k){ var e=sel('misure',k); if(e && e.value) s[k]=e.value; }); if(s.t!=='adattatori') delete s.f; return s; }
      function misurabile(m){ return m.t.semplici||m.t.doppia||m.t.adattatori; }
      var datiMisure=dati.filter(misurabile);
      function aggiornaMisure(){
        var s=scelteMisure();
        ORD_M.forEach(function(k){
          var e=sel('misure',k); if(!e) return;
          var altre={}; for(var x in s){ if(x!==k) altre[x]=s[x]; }
          var lista=valori(datiMisure,k,altre);
          if(k==='t') lista=lista.filter(function(v){ return TIPI_SCELTA.indexOf(v[0])>-1; });
          riempi(e,lista,k==='t'?'Tutti i tipi':(k==='s'?'Tutti gli spessori':'Tutte'),k,true);
        });
        var campoF=pannelli.misure.querySelector('[data-trp-campo="f"]');
        campoF.hidden=(sel('misure','t').value!=='adattatori');
        s=scelteMisure();
        var n=conta(datiMisure,s);
        var b=pannelli.misure.querySelector('[data-trp-vai]');
        var qualcosa=Object.keys(s).length>0;
        b.disabled=!qualcosa || n===0;
        b.querySelector('span').textContent=qualcosa ? (n ? 'Mostra '+n+(n===1?' prodotto':' prodotti') : 'Nessun prodotto') : 'Mostra distanziali';
      }
      ORD_M.forEach(function(k){ var e=sel('misure',k); if(e) e.addEventListener('change',aggiornaMisure); });
      pannelli.misure.querySelector('[data-trp-vai]').addEventListener('click',function(){
        var s=scelteMisure(); window.location.assign(indirizzo(s.t, ['p','f','c','s'].filter(function(k){ return s[k]; }).map(function(k){ return [k,s[k]]; }), null));
      });

      // ---------- Scheda "Per la tua auto" ----------
      function fitScelto(a){
        if(!a) return null;
        if(a.fit.length===1) return a.fit[0];
        var v=selForo.value; if(!v) return null;
        var r=null; a.fit.forEach(function(f){ if(f[0]+'|'+f[1]===v) r=f; }); return r;
      }
      function scelteAuto(){
        var a=autoScelta(), f=fitScelto(a), s={};
        if(f){ s.p=f[0]; s.c=f[1]; }
        var sp=sel('auto','s').value, tp=sel('auto','t').value;
        if(sp) s.s=sp; if(tp) s.t=tp;
        return {auto:a, fit:f, s:s};
      }
      function soloDistanziali(m){ return m.t.semplici||m.t.doppia; }
      function riempiForo(){
        var a=autoScelta(), campo=pannelli.auto.querySelector('[data-trp-campo="p"]'), aiuto=root.querySelector('[data-trp-aiuto-foro]');
        selForo.innerHTML='';
        if(!a || a.fit.length<2){ campo.hidden=true; aiuto.hidden=true; return; }
        selForo.appendChild(opzione('','Scegli la foratura'));
        var cbs={}; a.fit.forEach(function(f){ cbs[f[1]]=1; }); var cbUguale=Object.keys(cbs).length===1;
        a.fit.forEach(function(f){ selForo.appendChild(opzione(f[0]+'|'+f[1], f[0]+(cbUguale?'':' · foro '+f[1])+(f[3]?' ('+f[3]+')':''))); });
        selForo.disabled=false; campo.hidden=false;
        var fori={}; a.fit.forEach(function(f){ fori[f[0].split('x')[0]]=1; });
        aiuto.innerHTML = Object.keys(fori).length>1
          ? 'Questo modello esiste con forature diverse: <strong>conta i bulloni di una ruota</strong> ('+Object.keys(fori).sort().join(' o ')+') e scegli la foratura corrispondente.'
          : 'Questo modello esiste con forature diverse e lo stesso numero di bulloni: controlla la foratura sul cerchio o sul libretto, oppure scrivici modello e anno.';
        aiuto.hidden=false;
      }
      function aggiornaAuto(){
        var x=scelteAuto(), s=x.s;
        ['s','t'].forEach(function(k){
          var e=sel('auto',k);
          if(!x.fit){ riempi(e,[],k==='s'?'Tutti gli spessori':'Tutti i tipi',k,false); return; }
          var altre={p:s.p,c:s.c}; if(k==='s' && s.t) altre.t=s.t; if(k==='t' && s.s) altre.s=s.s;
          var lista=valori(dati.filter(soloDistanziali),k,altre);
          if(k==='t') lista=lista.filter(function(v){ return v[0]==='semplici'||v[0]==='doppia'; });
          riempi(e,lista,k==='s'?'Tutti gli spessori':'Tutti i tipi',k,true);
          if(k==='t' && !e.value && !e.getAttribute('data-toccato') && (tipoQui==='semplici'||tipoQui==='doppia') && lista.some(function(v){ return v[0]===tipoQui; })) e.value=tipoQui;
        });
        x=scelteAuto(); s=x.s;
        var b=pannelli.auto.querySelector('[data-trp-vai]');
        var n=x.fit ? dati.filter(function(m){ return soloDistanziali(m) && combacia(m,s); }).length : 0;
        b.disabled=!x.fit || n===0;
        b.querySelector('span').textContent = !x.fit ? 'Mostra distanziali' : (n ? 'Mostra '+n+(n===1?' distanziale':' distanziali') : 'Nessun distanziale');
        disegnaSchedaAuto(x,n);
      }
      function disegnaSchedaAuto(x,n){
        if(!x.fit){ schedaAuto.hidden=true; return; }
        var f=x.fit, righe=[];
        righe.push('<p class="trp-dist__misure">La tua <strong>'+esc(x.auto.marca+' '+x.auto.modello)+'</strong>: foratura <strong>'+esc(f[0])+'</strong> &middot; foro centrale <strong>'+esc(f[1])+' mm</strong>'+(f[2]?' &middot; filettatura <strong>'+esc(f[2])+'</strong>':'')+'</p>');
        var link=[];
        var thr=(f[2]||'').toLowerCase().split('/')[0];
        if(thr){
          var nb=conta(dati,{t:'bulloni',th:thr});
          if(nb || COLONNETTE[thr]) link.push('<li><strong>Distanziali:</strong> servono bulloni o colonnette più lunghi dello spessore del distanziale, passo '+esc(f[2])+'.'+(nb?' <a href="/collections/'+GRUPPO.bulloni+'/'+handleize(tagDi('th',thr))+'">Vedi bulloni '+esc(f[2])+' ('+nb+')</a>':'')+(COLONNETTE[thr]?(nb?' &middot;':'')+' <a href="/collections/colonnette-ruota/'+handleize(tagDi('th',thr))+'">Vedi colonnette '+esc(f[2])+'</a>':'')+'</li>');
          link.push('<li><strong>Doppia bulloneria:</strong> controlla che il passo indicato nella scheda del distanziale sia '+esc(f[2])+'.</li>');
        } else {
          link.push('<li><strong>Distanziali:</strong> servono bulloni o colonnette più lunghi; il passo lo trovi sul libretto o sul bullone originale. <a href="/collections/'+GRUPPO.bulloni+'">Vedi bulloni e dadi</a> &middot; <a href="/collections/colonnette-ruota">Vedi colonnette</a></li>');
        }
        var na=conta(dati,{t:'adattatori',p:f[0]});
        if(na) link.push('<li><strong>Vuoi montare cerchi con un\'altra foratura?</strong> <a href="/collections/'+GRUPPO.adattatori+'/'+handleize(tagDi('p',f[0]))+'">Adattatori per '+esc(f[0])+' ('+na+')</a></li>');
        if(!n){
          var fori=f[0].split('x')[0];
          righe.push('<p class="trp-cerchi__zero">Per questa combinazione non abbiamo distanziali pronti. Prova a togliere lo spessore o il tipo, guarda i <a href="/collections/'+GRUPPO.universali+((fori==='4'||fori==='5')?'/universale-'+fori+'-fori':'')+'">distanziali universali</a>, i <a href="/collections/'+MADRE+'/'+handleize(TAG_TIPO.sumisura)+'">distanziali su misura</a> oppure scrivici.</p>');
        }
        righe.push('<ul class="trp-dist__consigli">'+link.join('')+'</ul>');
        schedaAuto.innerHTML=righe.join('');
        schedaAuto.hidden=false;
      }
      selMarca.addEventListener('change',function(){ riempiModelli(); riempiForo(); aggiornaAuto(); });
      selMod.addEventListener('change',function(){ riempiForo(); aggiornaAuto(); var a=autoScelta(); if(a) memo('trpDistAuto',a.marca+'~'+a.modello); });
      selForo.addEventListener('change',aggiornaAuto);
      ['s','t'].forEach(function(k){ sel('auto',k).addEventListener('change',function(){ sel('auto',k).setAttribute('data-toccato','1'); aggiornaAuto(); }); });
      pannelli.auto.querySelector('[data-trp-vai]').addEventListener('click',function(){
        var x=scelteAuto(); if(!x.fit) return;
        var pezzi=[['p',x.s.p],['c',x.s.c]]; if(x.s.s) pezzi.push(['s',x.s.s]);
        window.location.assign(indirizzo(x.s.t, pezzi, x.auto.marca+'~'+x.auto.modello));
      });

      function indirizzo(tipo,pezzi,auto){
        var h=tipo && GRUPPO[tipo] ? GRUPPO[tipo] : MADRE;
        var url='/collections/'+h+(pezzi.length ? '/'+pezzi.map(function(x){ return handleize(tagDi(x[0],x[1])); }).join('+') : '');
        return url+(auto ? '?auto='+encodeURIComponent(auto) : '');
      }

      // ---------- Lettura dell'indirizzo (pagina dei risultati) ----------
      var dopo=(window.location.pathname.replace(/\/$/,'').split('/collections/')[1]||'').split('/');
      var pezziUrl=dopo[1] ? dopo[1].split('+') : [];
      var attuali={};
      ['p','f','c','s'].forEach(function(k){ valori(dati,k,{}).forEach(function(x){ if(pezziUrl.indexOf(handleize(tagDi(k,x[0])))>-1) attuali[k]=x[0]; }); });
      if(tipoQui) attuali.t=tipoQui;
      var autoUrl=new URLSearchParams(window.location.search).get('auto') || '';
      var autoTrovata=false;
      var ricordata=autoUrl || memo('trpDistAuto') || '';
      riempiModelli();
      if(ricordata.indexOf('~')>0){
        var pz=ricordata.split('~'), mk=pz[0], mo=pz.slice(1).join('~');
        if(AUTO[mk] && AUTO[mk].some(function(x){ return x[0]===mo; })){
          selMarca.value=mk; riempiModelli(); selMod.value=mo; riempiForo();
          var a=autoScelta();
          if(a && a.fit.length>1 && attuali.p){ a.fit.forEach(function(f){ if(f[0]===attuali.p && f[1]===attuali.c) selForo.value=f[0]+'|'+f[1]; }); }
          autoTrovata=!!autoUrl;
        }
      }
      aggiornaAuto();
      if(autoTrovata){
        if(attuali.s) sel('auto','s').value=attuali.s;
        if(attuali.t && (attuali.t==='semplici'||attuali.t==='doppia')) sel('auto','t').value=attuali.t;
        aggiornaAuto();
        mostraScheda('auto');
      } else {
        aggiornaMisure();
        ['t','p','f','c','s'].forEach(function(k){ var e=sel('misure',k); if(e && attuali[k]) e.value=attuali[k]; });
        aggiornaMisure();
        if(pezziUrl.length || tipoQui==='adattatori') mostraScheda('misure'); else mostraScheda('auto');
      }

      // Riepilogo sopra i risultati
      if(pezziUrl.length){
        var parti=[], filtro={};
        if(autoTrovata){ var aa=autoScelta(); parti.push('<strong>'+esc(aa.marca+' '+aa.modello)+'</strong>'); }
        if(attuali.t){ filtro.t=attuali.t; if(NOMI_TIPO[attuali.t]) parti.push('Tipo <strong>'+esc(NOMI_TIPO[attuali.t])+'</strong>'); }
        [['p','Foratura'],['f','Foratura cerchio'],['c','Foro centrale'],['s','Spessore']].forEach(function(x){ if(attuali[x[0]]){ filtro[x[0]]=attuali[x[0]]; parti.push(x[1]+' <strong>'+esc(etichetta(x[0],attuali[x[0]]))+'</strong>'); } });
        var n=conta(dati,filtro);
        riepilogo.innerHTML='Stai vedendo: '+parti.join(' &middot; ')+' &mdash; <strong>'+n+(n===1?' prodotto':' prodotti')+'</strong><a href="/collections/'+MADRE+'">Azzera ricerca</a>'+
          (n===0?'<span class="trp-cerchi__zero">Nessun prodotto con questa combinazione: prova a togliere lo spessore.</span>':'');
        riepilogo.hidden=false;
      }
    });

    [].slice.call(root.querySelectorAll('[data-trp-azzera]')).forEach(function(a){ a.addEventListener('click',function(e){ e.preventDefault(); memo('trpDistAuto',null); window.location.assign('/collections/'+MADRE); }); });
  });

  if(typeof module!=='undefined') module.exports={leggi:leggi, valori:valori, conta:conta, handleize:handleize, tagDi:tagDi};
})();
